import BasicRepository, {AllArgs, ListArgs} from "./basicRepository";
import Client from "../client";
import {TenantVariableResource} from "client/resources/tenantVariableResource";

interface TenantVariableListArgs extends ListArgs {
    projectId?: string;
}

interface TenantVariableAllArgs extends AllArgs {
    projectId?: string;
}

class TenantVariableRepository extends BasicRepository<TenantVariableResource, TenantVariableResource, TenantVariableListArgs, TenantVariableAllArgs> {
    constructor(client: Client) {
        super("TenantVariables", client);
    }
}

export default TenantVariableRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/tenantVariableRepository.ts